import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntegration = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.17578 13H5C2.79086 13 1 14.7909 1 17C1 18.1046 1.89543 19 3 19H8.17578M15 16H15.01M13 5C13 7.20914 11.2091 9 9 9C6.79086 9 5 7.20914 5 5C5 2.79086 6.79086 1 9 1C11.2091 1 13 2.79086 13 5ZM15 12L16.1787 13.1545L17.8284 13.1716L17.8455 14.8213L19 16L17.8455 17.1787L17.8284 18.8284L16.1787 18.8455L15 20L13.8213 18.8455L12.1716 18.8284L12.1545 17.1787L11 16L12.1545 14.8213L12.1716 13.1716L13.8213 13.1545L15 12Z",
		stroke: "#111111",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgIntegration);
export default ForwardRef;
